import React from "react";
import { ElementType } from "../../../shared/types";
import { ElementPlaceholder } from "../../../shared/Components/ElementPlaceholder/ElementPlaceholder";
export const EmbedView = ({
  element
}) => {
  const embedSettings = element?.settings;
  const embedCode = embedSettings?.code || "";
  const [isError, setIsError] = React.useState(false);
  const embedContainerRef = React.useRef(null);
  React.useEffect(() => {
    if (!embedCode) return;
    try {
      const parsedHTML = document.createRange().createContextualFragment(embedCode);
      if (embedContainerRef?.current) {
        // Clear previous content before appending
        embedContainerRef.current.innerHTML = "";
        embedContainerRef.current.appendChild(parsedHTML);
      }
    } catch (_error) {
      setIsError(true);
    }
  }, [embedCode]);
  return /*#__PURE__*/React.createElement("div", {
    id: element?.id,
    "data-test": "EmbedView",
    style: {
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }
  }, embedCode && !isError ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `
          .iframeContainer {
            position: relative;
            width: 100%;
            padding-top: 56.25%;
            height: 0;
            iframe {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: none;
              }
          }
          `), /*#__PURE__*/React.createElement("div", {
    ref: embedContainerRef,
    className: embedCode.includes("<iframe") ? "iframeContainer" : ""
  })) : /*#__PURE__*/React.createElement(ElementPlaceholder, {
    elementType: ElementType.Embed
  }));
};
//# sourceMappingURL=EmbedView.js.map